module.exports = __webpack_public_path__ + "static/media/middle-twoedge-2.065ffe49.png";